<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="box">
    <div class="logo">
      <img class="logo-one" src="@/assets/titlea.png" alt="">
      <img class="logo-tow" src="@/assets/titler.png" alt="">
    </div>

    <div class="header-sss">
      <img class="header-main-j" src="@/assets/mainj.png" alt="">
      <img class="header-main-ty" src="@/assets/minty.png" alt="">
      <img class="header-sss-jr" src="@/assets/mainj.png" alt="">
      <img class="header-sss-je" src="@/assets/minty.png" alt="">
      <img class="header-sss-jd" src="@/assets/maindl.png" alt="">
      <img class="header-main-dd" src="@/assets/maindd.png" alt="">

      <!-- 第1个带文字的图片 -->
      <div class="sss-item">
        <div class="sss-img-wrapper">
          <img class="sss-img" src="@/assets/titleimga.png" alt="">
          <div class="sss-img-text">优质空间,支持灵活协作</div>
        </div>
        <div class="sss-text">
          <p><span style="color:#ff4d4f;">荣获 iF 设计大奖的阳狮集团上海总部 ，位于新天地核心地段</span><span
              style="font-size: 10px;">。</span>舒适<span
              style="font-size: 10px;">、</span>现代化且充满活力的办公环境,为高效协作与多元工作方式提供有力支持;</p>
          <p>开放式超大公共空间——秋千、懒人沙发、游戏室等多元空间配置，让专注与放空自然切换;</p>
          <p>落地窗外即是上海地标“三件套”，让日常办公也带有城市的尺度与视野。</p>
        </div>
      </div>

      <!-- 第2个 -->
      <div class="sss-item">
        <div class="sss-img-wrapper">
          <img class="sss-img" src="@/assets/titleimgb.png" alt="">
          <div class="sss-img-text">AI赋能,驱动持续成长</div>
        </div>
        <div class="sss-text">
          <p><span style="color:#ff4d4f;">MarcelAI平台、PL.AI学习平台、行业大咖讲座等资源触手可及</span>，帮助员工不断提升专业能力与AI时代竞争力;</p>
          <p><span class="stitle-one" style="color:#ff4d4f;"><span class="stitle-tow">「出狮计划」「Lion Leap」「Next Generation Board」</span>等内部发展项目</span>，为不同阶段的职业成长提供更多探索与进阶机会。
          </p>
        </div>
      </div>

      <!-- 第3个 -->
      <div class="sss-item">
        <div class="sss-img-wrapper">
          <img class="sss-img" src="@/assets/titleimgc.png" alt="">
          <div class="sss-img-text">多元活动,连接同频伙伴</div>
        </div>
        <div class="sss-text">
          <p>Sports Day<span style="font-size: 9px;">、</span>AI Day<span
              style="font-size: 9px;">、</span>电影之夜到各类节日活动，在工作之余，增添更多乐趣;</p>
          <p><span style="color:#ff4d4f;">由员工自主发起活动的专属平台【LionBuddy】</span>,帮助员工在集团内快速找到志同道合的“兴趣搭子”，在轻松玩乐中共同成长。</p>
        </div>
      </div>

      <!-- 第4个 -->
      <div class="sss-item">
        <div class="sss-img-wrapper">
          <img class="sss-img" src="@/assets/titleimgd.png" alt="">
          <div class="sss-img-text">丰富福利,保障身心状态</div>
        </div>
        <div class="sss-text">
          <p>从工作到生活，我们关注每一位员工的身心状态;</p>
          <p>每日免费咖啡、畅休假期-国定调休日不上班、专属餐饮与健身优惠等多元福利，为员工提供更多便利与保障;</p>
          <p>超人气年会、巴黎总部游等惊喜不定期掉落，让工作体验持续拉满。</p>
        </div>
      </div>

      <div class="title-one">*正式员工可享有</div>
    </div>
    <div class="logo">
      <img class="logo-one logintow" src="@/assets/titletow.png" alt="">
      <img class="logo-tow logintowy" src="@/assets/titletowy.png" alt="">
    </div>

    <div class="header-lbt">
      <div class="lbt-title">办公环境</div>

      <swiper :modules="modules" :loop="true"
        :autoplay="{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }" :slides-per-view="3"
        :centered-slides="true" :space-between="20" :pagination="{ clickable: true }" :breakpoints="{
          768: { slidesPerView: 3 },
          0: { slidesPerView: 1 }
        }" class="my-swiper">
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">茶水间</div>
            <img src="@/assets/bg/csj.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title slide-titler">Grand Pantry</div>
            <img src="@/assets/bg/Grand Pantry  .jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">沙发秋千</div>
            <img src="@/assets/bg/sf.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">咖啡吧</div>
            <img src="@/assets/bg/kfb.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">中央楼梯</div>
            <img src="@/assets/bg/zylt.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">中央休息区</div>
            <img src="@/assets/bg/xx.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="header-lbt header-lbt-tow">
      <div class="lbt-title">Viva la différence</div>

      <swiper :modules="modules" :loop="true"
        :autoplay="{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }" :slides-per-view="3"
        :centered-slides="true" :space-between="20" :pagination="{ clickable: true }" :breakpoints="{
          768: { slidesPerView: 3 },
          0: { slidesPerView: 1 }
        }" class="my-swiper">
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">100周年</div>
            <img src="@/assets/bg/b.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">100周年</div>
            <img src="@/assets/bg/e.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">100周年</div>
            <img src="@/assets/bg/c.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">智造赋能</div>
            <img src="@/assets/bg/fn.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">智造赋能</div>
            <img src="@/assets/bg/fne.jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide-item">
            <div class="slide-title">Sports Day</div>
            <img src="@/assets/bg/Sports Day .jpg" alt="" class="slide-btn">
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper/modules'

const modules = [Autoplay, Pagination]
</script>

<style scoped>
* {
  box-sizing: border-box;
  text-autospace: none !important;
}

br {
  content: "";
  display: block;
}

.box {
  width: 100%;
  height: auto;
  overflow-x: hidden;
}

.logo {
  width: 1420px;
  margin: 0 auto;
}

.logo img {
  width: 100%;
  /* margin-top: 40px; */
}

.logo-one {
  display: block;
}

.logo-tow {
  display: none;
}

.logo .logintow {
  width: 90%;
  margin-top: -20px;
}

.header-lbt {
  width: 1000px;
  height: 400px;
  margin: 0 auto;
  padding: 20px 0;
  position: relative;
  overflow: hidden;
}

.header-sss {
  width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
  position: relative;
  margin-top: 50px;
  height: auto;
}

.header-sss-j {
  position: absolute;
  right: -100px;
  top: 65%;
  width: 13px;
}

.header-sss-jr,
.header-sss-je,
.header-sss-jd {
  display: none;
}

.sss-item {
  margin-bottom: 40px;
}

/* 图片容器 + 文字叠加 */
.sss-img-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
}

.sss-img {
  height: 70px;
  display: block;
}

.sss-img-text {
  position: absolute;
  top: 60%;
  left: 57%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 23px;
  white-space: nowrap;
  pointer-events: none;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 700;
}

.sss-text {
  width: 70%;
}

.sss-text p {
  font-size: 17px;
  line-height: 1.8;
  color: #333;
  margin: 10px 0;
  text-align: left;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;
  padding-left: 7px;
  position: relative;
  text-align: justify;
  line-break: strict;
  word-break: break-all;
}

.sss-text p span {
  font-weight: 700;
}

:deep(.sss-text p::before) {
  content: '';
  flex-shrink: 0;
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #ff4d4f;
  position: absolute;
  left: 0;
  top: 12px;
}

.lbt-title {
  width: 100%;
  height: 80px;
  background: url("@/assets/titlelbt.png") no-repeat center;
  background-size: contain;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 700;
}

:deep(.swiper-slide) {
  opacity: 0.8;
  transform: scale(0.85);
  transition: all 0.4s ease;
  height: 200px;
  display: block;
  transition: none !important;
}

:deep(.swiper-slide-active) {
  opacity: 1;
  transform: scale(1);
  height: 240px;
}

.slide-item {
  width: 100%;
  height: 100%;
  background: url("@/assets/titlelbtk.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.slide-title {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  color: #fff;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 400;
}

.slide-btn {
  width: 98%;
  height: 80%;
  margin-top: 20px;
}

:deep(.swiper) {
  overflow: visible;
}

:deep(.swiper-pagination-bullet) {
  background: #fff !important;
  border: 1px solid #ff4d4f;
  opacity: 0.5;
}

:deep(.swiper-pagination-bullet-active) {
  background: #ff4d4f !important;
  opacity: 1;
}

:deep(.swiper-pagination) {
  bottom: -20px !important;
}

.header-lbt-tow {
  margin-bottom: 100px;
}

.header-main-dd {
  position: absolute;
  right: 10%;
  top: 15%;
  width: 130px;
  height: auto;
}

.header-main-j {
  position: absolute;
  left: -40px;
  top: 42%;
  width: 10px;
  height: auto;
}

.header-main-ty {
  position: absolute;
  right: 120px;
  top: 50%;
  width: 10px;
  height: auto;
}

.nav-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #F87373;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  z-index: 9999;
}

.nav-item {
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: color 0.3s ease;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;
}

.nav-itemhover {
  color: #fff;
}

.bra {
  display: none;
}

.bre {
  display: block;
}

.title-one {
  width: 100%;
  text-align: right;
  font-size: 12px;
  color: #ccc;
}

@media (max-width: 768px) {
  .logo-one {
    display: none;
  }

  .logo-tow {
    display: block;
  }

  .header-sss {
    width: 88%;
    padding-bottom: 0px;
    padding-top: 0px;
  }

  .sss-text p {
    font-size: 12.5px;
    line-height: 1.4;
    margin: 4px auto;
    word-break: break-all !important;
    overflow-wrap: break-word !important;
    white-space: normal !important;
    text-rendering: geometricPrecision !important;
  }

  .header-lbt {
    width: 67% !important;
    height: 340px;
  }

  .lbt-title {
    transform: scale(0.8);
  }

  .logo img {
    margin-top: 0px;
  }

  /* 移动端图片文字缩小 */
  .sss-img {
    height: 30px;
  }

  .sss-img-text {
    font-size: 10px;
  }

  .header-sss {
    margin-top: 30px;
  }

  :deep(.swiper-slide-active) {
    height: 190px;
  }

  .header-main-dd {
    position: absolute;
    right: -40px;
    top: 0%;
    width: 35px;
    height: auto;
  }

  .header-main-j {
    position: absolute;
    left: -20px;
    top: 80px;
    width: 6px;
    height: auto;
  }

  :deep(.sss-text p::before) {
    top: 7px;
  }

  .header-main-ty {
    position: absolute;
    right: 0px;
    top: 90px;
    width: 4px;
    height: auto;
  }

  .nav-bar {
    height: 50px;
    gap: 15px;
    padding: 0 10px;
  }

  .nav-item {
    font-size: 12px;
  }

  .sss-text {
    width: 100%;
  }

  .bra {
    display: block;
  }

  .bre {
    display: none;
  }

  .title-one {
    width: 100%;
    text-align: right;
    font-size: 8px;
    color: #ccc;
  }

  .logo {
    width: 100%;
  }

  .box {
    width: 375px !important;
    margin: 0 auto;
    margin-top: 20px;
    padding: 0 2px;
  }

  .slide-titler {
    font-size: 11px;
  }

  .lbt-title {
    font-size: 22px;
  }

  .stitle-one {
    color: #ff4d4f;
    text-align: left;
    display: inline;
    
  }
  .stitle-tow{
 white-space: nowrap !important;
    word-break: keep-all;
    hyphens: none;
    overflow-wrap: normal;
  }
}
</style>